import { render, staticRenderFns } from "./TitleAndEdit.vue?vue&type=template&id=48d4414c"
import script from "./TitleAndEdit.vue?vue&type=script&lang=js"
export * from "./TitleAndEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports